<template>
  <div ref="chartDom" id="chart" style="height:100%;"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { BarChart,LineChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([TitleComponent, TooltipComponent, GridComponent, BarChart,LineChart, CanvasRenderer,LegendComponent])
export default {
  props:['result'],
  data(){
    return {
      option: {
        grid: {
          left: 20,
          right: 280,
          bottom: 40,
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 20
        }, {
          start: 0,
          end: 20
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          textStyle:{
            width:200,
            height:20,
            fontSize:12,
            lineOverflow:'truncate',
            lineHeight:18,
            ellipsis :'..',
            overflow:'break',
          },
          itemWidth:16,
          itemHeight:10,
          width:200,
          height:'90%',
          right: 10,
          top: 20,
          bottom: 200,
          data: ['蒸发量', '降水量', '平均温度']
        },
        xAxis:{
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          // boundaryGap: false,
          // axisPointer: {
          //   type: 'shadow'
          // },
          // axisLine: {onZero: false},
        },
        yAxis:[{
          type: 'value',
          name: '数值',
          },
          {
            type: 'value',
            name: '价格',
            axisLabel: {
              formatter: '{value} 元'
            }
          }
        ],
        series: [
          {
            name: '蒸发量',
            type: 'line',
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
          },
        ]
      },
    }
  },
  created(){
    this.initOption()
  },
  methods:{
    initOption(){
      const {ladderList,rawResList} = this.result
      console.log('ladderList',ladderList)
      if(ladderList && rawResList) {
        this.option.xAxis.data = ladderList
        this.option.legend.data = rawResList[0].map(i => i.name)
        // this.option.series[0].data = nutritionResList[0].map(i=>i.percentage)
        let series = rawResList[0].map((i) => {
          return { 
            name: i.name,
            data:[]
          }
        })
        rawResList.forEach(item => {
          item.forEach((i,id) => {
            series[id] = {
              name: i.name,
              code: i.code,
              type: id === 0 ? 'bar' : 'line',
              yAxisIndex: id === 0 ? 1 : 0,
              data:[...series[id].data, i.percentage]
            }
          })
        })
        this.option.series =  series
        this.$nextTick(()=> {
          this.initChart()
        })
        }
    },
    initChart(){
      var myChart = echarts.init(document.getElementById('chart'))
      myChart.setOption(this.option)
    }
  }
}
</script>

<style>

</style>